import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full border border-white/15 bg-ink px-4 py-3 text-sm text-paper placeholder:text-muted2/60 outline-none transition-colors duration-200 focus:border-brand";

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-ink px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-white/10 bg-coal p-8">
        <Link to="/" data-testid="login-logo-link"><Logo height={80} /></Link>
        <h1 className="mt-8 font-display text-2xl font-black uppercase text-paper">Beheerderspaneel</h1>
        <p className="mt-1 text-sm text-muted2">Meld je aan om offerte-aanvragen te bekijken.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mailadres" className={inputCls} data-testid="admin-email-input" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Wachtwoord" className={inputCls} data-testid="admin-password-input" />
          {error && <p className="border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 bg-brand px-6 py-3 font-display text-lg font-bold uppercase text-ink transition-colors hover:bg-safety disabled:opacity-60"
            data-testid="admin-login-submit-btn"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Aanmelden
          </button>
        </form>
      </div>
    </div>
  );
}
